import { getSettings_settings, webshopMenuItems_webshopMenuItems } from "@api/graphql/types";

export type AppDataReducerType = {
    menuItems: webshopMenuItems_webshopMenuItems[];
    settings: getSettings_settings;
};

export const initialState: AppDataReducerType = {
    menuItems: [],
    settings: {
        price_friendly_txt: "",
        captcha_enabled: false,
        captcha_keys: [],
        __typename: "Settings",
    },
};

export default function AppDataReducer(state: AppDataReducerType = initialState): AppDataReducerType {
    return state;
}
